import { useFormik } from 'formik'
import * as Yup from 'yup'
import { isClass } from 'src/tools'
import InputField from 'src/components/formik/input-field'

const InviteModal = ({ active, item, onSubmit, onClose }) => {
  const formik = useFormik({
    initialValues: {
      student_email: '',
      name: item?.name,
      avatar: 1,
    },
    validationSchema: Yup.object().shape({
      student_email: Yup.string().required().email(),
      name: Yup.string().required(),
      avatar: Yup.number().min(1).max(12),
    }),
    onSubmit: async (values) => {
      await onSubmit({
        classroom_id: item?.id,
        ...values,
      })
    },
  })

  const handleClose = () => {
    formik.resetForm()
    onClose()
  }

  return (
    <>
      <div className={`popup-overview ${active ? 'active' : ''}`} />
      <div className={`modals popup ${active ? 'active' : ''}`}>
        <div className="modals__wrapper">
          <div className="modals__head">
            <h3 className="modals__title">Invite student to {item?.name}</h3>
            <button onClick={onClose} type="button" className="modals__close">
              <img src="/account/images/dest/icons/close.svg" alt="Close" />
            </button>
          </div>

          <div className="modal modals__body">
            <form
              onSubmit={formik.handleSubmit}
              action="/"
              className="modals__form"
            >
              <div className="row">
                <div className="col-12 col-md-12">
                  <InputField formik={formik} name="name">
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Student’s name"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                  </InputField>
                </div>
              </div>

              <div className="row">
                <div className="col-12 col-md-12">
                  <InputField formik={formik} name="student_email">
                    <label>Email</label>
                    <input
                      type="text"
                      name="student_email"
                      placeholder="Email"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                  </InputField>
                </div>
              </div>

              {/* <div className="modals__icons__wrapper">
                <div className="row">
                  {new Array(12).fill(0).map((_, i) => (
                    <div key={i} className="col-md-2 col-4">
                      <button
                        type="button"
                        className={`modals__yummy ${isClass(formik.values.avatar === i + 1, 'active')}`}
                        onClick={() => { formik.setFieldValue('avatar', i + 1) } }
                      >
                        <img
                          src={`/account/account/images/dest/student__profile/yummy/${i+1}.svg`}
                          alt="yummy" className="modals__yummy__img"
                        />
                        <span className="modals__yummy__status">
                          <img src="/account/account/images/dest/student__profile/ok.svg" alt="ok" />
                        </span>
                      </button>

                    </div>
                  ))}
                </div>
              </div> */}

              <p className="actions">
                <button type="submit" className="primary-btn">
                  Invite student
                </button>

                <button
                  type="button"
                  className="second-btn"
                  onClick={handleClose}
                >
                  Cancel
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default InviteModal
